import config from '../../../config'

export const SendErrorEmailReducer = ( data ) => async ( req, res ) => {
    const { cardName, userName, status, message, notifications, error } = data;

    try {
        const response = await fetch(config.api+'upload-file/notification/error/upload-file', {
            mode:'cors',
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-type': 'application/json',
                'usutoken': localStorage.getItem('usutoken')
            },
            body: JSON.stringify({
                cardName,
                userName,
                status,
                message,
                notifications,
                error,
            }),
        });

        const result = await response.json();

        return result.message;

    } catch (error) {
        console.error('Error enviando el email', error);
        throw error;
    }
}